import { render } from "./news-video.vue?vue&type=template&id=478ca642&scoped=true"
import script from "./news-video.vue?vue&type=script&lang=js"
export * from "./news-video.vue?vue&type=script&lang=js"

import "./news-video.vue?vue&type=style&index=0&id=478ca642&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478ca642"]])

export default __exports__